// src/ckeditor/customEditor.js
import {
  ClassicEditor as ClassicBase,
  Essentials,
  Paragraph,
  Bold,
  Italic,
  Heading,
  Link,
  List,
  BlockQuote,
  Table,
  MediaEmbed,
  PasteFromOffice,
  Font,
  Alignment,
} from "ckeditor5";
import "ckeditor5/ckeditor5.css";

// Create a stable editor class so React doesn't recreate it on every render
class Editor extends ClassicBase {}
Editor.builtinPlugins = [
  Essentials,
  Paragraph,
  Bold,
  Italic,
  Heading,
  Link,
  List,
  BlockQuote,
  Table,
  MediaEmbed,
  PasteFromOffice,
  Font,
  Alignment,
];

Editor.defaultConfig = {
  
  toolbar: [
    "heading",
    "|",
    "bold",
    "italic",
    "link",
    "|",
    "bulletedList",
    "numberedList",
    "blockQuote",
    "|",
    "alignment",
    "fontSize",
    "fontFamily",
    "fontColor",
    "fontBackgroundColor",
    "|",
    "undo",
    "redo",
  ],
  table: { contentToolbar: ["tableColumn", "tableRow", "mergeTableCells"] },
  link: { decorators: { addTargetToExternalLinks: true } },
  placeholder: "",
  licenseKey: "GPL", // if you're using the GPL build
};

export default Editor;
